import {
  PROPERTY_LIST,
  PROPERTY_DETAIL,
  APPLY_PROPERTY,
  PROPERTY_WATCH,
  TENANT_LIST,
  ACTIVE_PROPERTY_LIST,GET_TENANT_TABLE,RENTER_LIST_DETAILS
} from "../actions/types";

const initialState = {
  property: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  tenantTable: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  propertyLoading: true,
  propertyData: {},
  propertyWatch: {},
  tenantList: {},
  rentersListDetails:{},
  getActiveAllProperty: [],
};

const propertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PROPERTY_LIST:
      return {
        ...state,
        property: payload,
        propertyLoading: false,
      };
    case PROPERTY_DETAIL:
      return {
        ...state,
        propertyData: payload,
        propertyLoading: false,
      };

    case APPLY_PROPERTY:
      return {
        ...state,
        propertyData: payload,
        propertyLoading: false,
      };

    case PROPERTY_WATCH:
      return {
        ...state,
        propertyWatch: payload,
        propertyLoading: false,
      };

    case TENANT_LIST:
      return {
        ...state,
        tenantList: payload,
        propertyLoading: false,
      };
    case RENTER_LIST_DETAILS:
      return {
        ...state,
        rentersListDetails:payload
      }
    case ACTIVE_PROPERTY_LIST:
      return {
        ...state,
        getActiveAllProperty: payload,
        propertyLoading: false,
      };
      case GET_TENANT_TABLE:
        return {
          ...state,
          tenantTable: payload,
          loading: false,
        };

    default:
      return state;
  }
};

export default propertyReducer;
